import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toInteger'
})
export class ToIntegerPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return null;
  }
}
